/*
 * Wunschmoment Offer A/B Test (offer_2026)
 * Freier Versand per Rabattcode NUR für die Offer-Variante:
 * Der Checkout-Klick wird über den Shopify-Discount-Link geleitet
 * (/discount/CODE?redirect=/checkout) → Code landet in der Session,
 * an der Kasse ist der Versand durchgestrichen (kostenlos) inkl. Code.
 *
 * Kein Automatik-Rabatt nötig → greift dadurch nur bei Offer-Usern,
 * Variante A (Control) bekommt den Code nie.
 *
 * Voraussetzung in Shopify: Code existiert (Typ: kostenloser Versand),
 * kombinierbar mit dem automatischen Produktrabatt "Aktionspreis".
 */
(function () {
  'use strict';

  var FREE_SHIPPING_CODE = 'VERSAND100';

  /* shipping_2026 beendet 2026-08-26 (Sieger `separate`): data-shipping="included" wird nicht
     mehr gesetzt. Warenkörbe, die noch ein Ship-Produkt enthalten (Preis inkl. Versand),
     brauchen den Code aber weiterhin — sonst wird auf einen Versand-inklusive-Preis nochmal
     Versand berechnet. Erkennung am Warenkorb-Markup statt am Flag, damit sie auch nach dem
     Neurendern der Cart-Section (Menge ändern/Position löschen) stimmt. */
  var SHIP_PATHS = ['/products/lieblingsfoto-als-puzzle', '/products/rahmen-puzzle'];

  function cartHasShipItem() {
    var links = document.querySelectorAll('.cart-item a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var p;
      try { p = new URL(links[i].href, window.location.origin).pathname; } catch (err) { continue; }
      for (var j = 0; j < SHIP_PATHS.length; j++) {
        if (p === SHIP_PATHS[j] || p.indexOf(SHIP_PATHS[j] + '/') === 0) return true;
      }
    }
    return false;
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('#CartDrawer-Checkout, #checkout');
      if (!btn || btn.disabled) return;

      /* Gratisversand-Code für Alt-Offer (data-offer=offer) UND Alt-Warenkörbe mit Ship-Produkten.
         Prüfung erst hier, damit sie nicht bei jedem Klick im Dokument läuft. */
      var de = document.documentElement;
      if (de.getAttribute('data-offer') !== 'offer' && !cartHasShipItem()) return;

      // Standard-Formular-Submit zur Kasse abfangen und über den Discount-Link leiten
      e.preventDefault();
      e.stopPropagation();
      window.location.href = '/discount/' + FREE_SHIPPING_CODE + '?redirect=/checkout';
    },
    true // Capture-Phase: vor dem Form-Submit abfangen
  );
})();
